import React, { useEffect, useState } from 'react';
import { useStores } from '@stores/context.jsx';
import FullPageLoader from '@common/Loader/FullPageLoader';
import { Navigate } from 'react-router';

const AuthRenew = () => {
    const [loading, setLoading] = useState(true);
    const { authStore } = useStores();
    useEffect(() => {
        authStore.completeRenew().then(() => setLoading(false));
    }, [authStore]);
    return loading ? <FullPageLoader /> : <Navigate to={authStore.getRootURIForUser()} />;
};

export default AuthRenew;
